<template>
  <div :class="$style.container" v-observe-visibility="{
    callback: onVisibilityChanged,
    once: true,
    intersection: {
      threshold: 1
    }
  }">
    <span
      v-if="isShowToggleButton"
      :class="$style.button"
      @click="isOpened = !isOpened"
    >
      <template v-if="!isOpened">
        <BaseIcon name="chevron-down" :class="$style.arrow" />{{ $t('socialPost.viewLatestComments') }}
      </template>
      <template v-else>
        <BaseIcon name="chevron-up" :class="$style.arrow" />{{ $t('socialPost.hideComments') }}
      </template>
    </span>
    <SocialCommentsListItem
      v-for="comment in commentsDisplay" :key="comment.id"
      :comment="comment"
    />
    <span v-if="isOpened && isNext" :class="$style.button" @click="showMore">{{ $t('buttonLoadMore') }}</span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SocialCommentsListItem from './SocialCommentsListItem'
import { ObserveVisibility } from 'vue-observe-visibility'
import Vue from 'vue'

Vue.component('SocialCommentsListItem', SocialCommentsListItem)

const LIMIT = 10

export default {
  name: 'social-comments-list',
  directives: {
    ObserveVisibility
  },
  props: {
    postId: Number
  },
  data () {
    return {
      isOpened: false,
      isNext: false
    }
  },
  computed: {
    ...mapGetters({
      getPostComments: 'entities/socialComments/getPostComments'
    }),
    comments () {
      return this.getPostComments(this.postId)
    },
    isShowToggleButton () {
      return this.isOpened || (this.comments && this.isNext) // this.comments.length > 1
    },
    toggleButtonTxt () {
      return this.isOpened ? this.$t('socialPost.hideComments') : this.$t('socialPost.viewLatestComments')
    },
    commentsDisplay () {
      if (!this.comments || !this.comments.length) return []
      return this.isOpened ? this.comments : [this.comments[0]]
    },
    offset () {
      return this.comments && this.comments.length ? this.comments.length - 1 : 0
    }
  },
  watch: {
    isOpened (isOpened) {
      if (isOpened) {
        this.onFetch(0)
      } else {
        this.clearData()
      }
    }
  },
  methods: {
    ...mapActions({
      fetchPostComments: 'entities/socialComments/fetchPostComments'
    }),
    onVisibilityChanged (isVisible) {
      if (!isVisible) return
      this.onFetch(0)
    },
    async onFetch (offset) {
      const { isNext } = await this.fetchPostComments({ postId: this.postId, limit: LIMIT, offset })
      this.isNext = isNext
    },
    showMore () {
      this.onFetch(this.offset)
    },
    clearData () {
      this.isNext = true
      const [, ...restComments] = this.comments
      restComments.forEach(comment => comment.$delete())
    }
  }
}
</script>

<style module lang="scss">
.container {
  margin-top: 10px;
}
.button {
  color: $text-colored;
  cursor: pointer;
  // &:hover {
  //   color: $text-darkest;
  // }
}
.arrow {
  margin-right: 4px;
}
</style>
